import { gql } from '@apollo/client';

const PARTNER_LINK_FRAGMENT = gql`
  fragment partnerLinkFields on PartnerLink {
    defaultPartnerChannel {
      id
      name
      channel
    }
    fineGrainedRights {
      aggregatedPermissions
      partnerChannel {
        channel
      }
      roleName
    }
    defaultPermissions
    partnerAccount {
      id
      partnerNumber
      name
      quota {
        maxNotifications
        maxNotificationDays
        maxDocuments
      }
      features
      rootPartnerChannel {
        id
        channel
        name
      }
      partnerProfile {
        id
      }
    }
    defaultRoleName
  }
`;

const GET_ME_QUERY = gql`
  query Query {
    metaQuery {
      me {
        id
        email
        firstName
        lastName
        links {
          defaultPartnerChannel {
            id
            name
            channel
          }
          fineGrainedRights {
            aggregatedPermissions
            partnerChannel {
              channel
            }
            roleName
          }
          defaultPermissions
          partnerAccount {
            id
            defaultInterestTags
            isFilteredWithInterestTags
            features
            name
            partnerProfile {
              id
            }
            partnerNumber
            quota {
              maxNotifications
              maxNotificationDays
              maxDocuments
            }
            rootPartnerChannel {
              id
              channel
              name
            }
          }
          defaultRoleName
        }
      }
    }
  }
`;

export { GET_ME_QUERY, PARTNER_LINK_FRAGMENT };
